/* Specific helper for single navigation items */

/* STORES */
import { useAuthStore } from '@/stores/auth';
import { useLocaleStore } from '@/stores/locales';
/* TYPES */
import type { NavItemType } from '@/types/navigation/navigation.types';

/**
 * Navbar top-level menus
 */
export const networkMenu: NavItemType = {
  icon: 'fat fa-chart-network',
  label: 'navigation.recruiter.network.rollover',
  permissions: ['recruiter_r'],
  route: '/recruiter/network'
};

export const recruitmentMenu: NavItemType = {
  icon: 'fat fa-handshake',
  label: 'navigation.recruiter.recruitment.hire'
};

export const talentMenu: NavItemType = {
  icon: 'fat fa-gem',
  label: 'navigation.recruiter.talent.develop'
};

/**
 * Constants to be used in navigation components
 */
// User menu

export const candidate: NavItemType = {
  icon: 'fat fa-user-circle',
  label: 'navigation.go_to.candidate_portal',
  externalRedirection: {
    type: 'personal_account_url',
    route: 'profile'
  }
};

export const settings: NavItemType = {
  icon: 'fat fa-cog',
  label: 'navigation.go_to.account_settings',
  externalRedirection: {
    type: 'personal_account_url',
    route: 'settings'
  }
};

export const ambassador: NavItemType = {
  icon: 'fat fa-medal',
  label: 'navigation.go_to.ambassador_portal',
  permissions: ['recruiter_r'],
  isVisible: () => useLocaleStore().getCurrentISO === 'fr-FR' && !!useAuthStore().getFullUser?.user_data?.hubspot_id,
  isNew: () => useAuthStore().getFullUser?.user_data?.is_ambassador === false,
  route: '/recruiter/ambassador'
};

export const integrations: NavItemType = {
  icon: 'fat fa-magnet',
  permissions: ['recruiter_r'],
  label: 'navigation.go_to.integrations',
  externalRedirection: {
    type: 'gaston_url',
    route: 'integrations'
  }
};

export const browserExtension: NavItemType = {
  icon: 'fat fa-puzzle-piece',
  label: 'navigation.go_to.extension',
  externalRedirection: {
    type: 'link',
    route: 'browser_extension',
    modalRedirection: true
  },
  reporter: {
    name: 'click_plug_in'
  }
};

export const help: NavItemType = {
  icon: 'fat fa-question-circle',
  label: 'navigation.help',
  externalRedirection: {
    type: 'link',
    route: 'help',
    handleLanguage: true
  }
};

export const logout: NavItemType = {
  icon: 'fat fa-sign-out',
  label: 'navigation.logout',
  route: '/logout'
};

export const admin: NavItemType = {
  icon: 'fat fa-user-shield',
  label: 'navigation.go_to.admin_portal',
  permissions: ['company_admin_r'],
  externalRedirection: {
    type: 'admin_url',
    route: ''
  }
};

export const sharedProfiles: NavItemType = {
  label: 'navigation.recruiter.network.shared_candidates',
  permissions: ['manager_r'],
  externalRedirection: {
    type: 'gaston_url',
    route: 'sharedProfiles'
  }
};

// Recruitement
export const campaigns: NavItemType = {
  label: 'navigation.recruiter.recruitment.campaigns',
  permissions: ['campaign_r'],
  route: '/recruiter/campaigns',
  datacy: 'hire-campaign'
};

export const predictiveModels: NavItemType = {
  label: 'navigation.recruiter.recruitment.models',
  permissions: ['predictive_model_r'],
  route: '/recruiter/predictive_models',
  datacy: 'predictive-models'
};

// Talent
export const teamAnalysis: NavItemType = {
  label: 'navigation.recruiter.talent.team_analysis',
  permissions: ['talent_analysis'],
  route: '/recruiter/team-analysis'
};

export const mobility: NavItemType = {
  label: 'navigation.recruiter.talent.mobility',
  permissions: ['mobility_r'],
  externalRedirection: {
    type: 'gaston_url',
    route: 'mobility'
  }
};

export const competencyFrameworkGroup: NavItemType = {
  label: 'navigation.recruiter.talent.management',
  permissions: ['competency_framework_group_r'],
  route: '/recruiter/competency_framework'
};
